var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"more",on:{"click":_vm.loadMore}},[_vm._v("查看更多")])
}
var staticRenderFns = []

export { render, staticRenderFns }